import { render } from "./user.vue?vue&type=template&id=1683f0db&scoped=true"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"

import "./user.vue?vue&type=style&index=0&id=1683f0db&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1683f0db"

export default script